"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createImports = void 0;
var provideStoreInstance_1 = require("./provideStoreInstance");
var isObject = function (value) {
    var type = typeof value;
    return value != null && type === 'object' && !Array.isArray(value);
};
function createImports(object, method, namespace) {
    if (namespace === void 0) { namespace = ''; }
    if (!object || !isObject(object)) {
        console.error("[vuex-typed] Wrong argument passed to 'get' function! Expected: 'object', received: '" + typeof object + "'");
        return {};
    }
    var keys = Object.keys(object);
    var args = !namespace ? [keys] : [namespace, keys];
    return provideStoreInstance_1.provideStoreInstance(method.apply(void 0, args));
}
exports.createImports = createImports;
